import EncryptUtility from "../../utility/js/encrypt-utility.js";
import authHeader from "../../../services/auth-header";
import jwt_decode from "jwt-decode";
import { APPCODE } from "../../utility/js/constants-utility";
// import BrowserUtility from "../../utility/js/browser-utility";
import Utility from "../../../shared/utility";
import commonAPIService from "../../../components/common/js/common-api-service";
export default {
  data() {
    return {
      logoImg: require("@/assets/images/RLP.png"),
      valid: true,
      email: "",
      password: "",
      isPasswordShow: false,
      userId: 0,
      decoded: [],
      expiredTime: 0,
      currentTime: 0,
      urlArray: [],
      uralArrayPageAction: [],
      permission: [],
      cookieTime: 60 * 60 * 24 * 365,
      emailRules: [(v) => !!v || "Email is required", (v) => /^(?!.*\.\.)(?!.*\s)[A-Za-z0-9]+([._%+-]?[A-Za-z0-9]+)*@[A-Za-z0-9]+(-[A-Za-z0-9]+)*(\.[A-Za-z]{2,})+$/.test(v) || "Email must be valid"],
      passwordRules: [(v) => !!v || "Password is required"],
      ipData: [],
      forgotPasswordDialog: false,
      forgotPasswordValid: false,
      btnActiveSession: false,
      forgotEmail: "",
      captchaReceived: false,
      captchaCode: "",
      captchaText: "", // Changed from captchaImage to captchaText - now showing as plain text instead of image
      captchaInput: "",
      // Password reset dialog properties
      passwordResetDialog: false,
      passwordResetValid: false,
      newPassword: "",
      confirmPassword: "",
      isNewPasswordShow: false,
      isConfirmPasswordShow: false,
      tempUserId: null,
      tempUserData: null,
      tempOldPassword: "",
      rules: {
        required: (value) => !!value || "This field is required",
        passwordRules: (value) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#])[A-Za-z\d@$!%*?&.#]{8,20}$/;
          return pattern.test(value) || 'Password must contain 8-20 characters with at least one uppercase, one lowercase, one number and one special character (@$!%*?&.#)';
        },
      },
      rlpTheme: {
        primary: "#005ba8",
        secondary: "#f89554",
        menubreadcrums: "#FFFFFF",
        containerbox: "#FFFFFF",
        primarytext: "#005ba8",
        navlinks: "#005ba8",
        activeColor: "#2ed8b6",
        inactiveColor: "#ff5370",
        background: "#f4f5fa",
        tertiary: "#e9e7f7",
        customwhite: "#FFFFFF",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        customLightGrey: "#EBEEF3",
        cWhite: "#FFFFFF",
        red: "#DC143C",
      },
    };
  },
  mounted() {

    // Check for existing JWT expiration time on component mount to determine if active session message 
    // should be shown
    const jwtExp = EncryptUtility.localStorageDecrypt("JWTExp");

    // Perform initial and necessary calls on component mount
    this.initialCalls();

    // If JWT expiration time exists, delay the login button activation for 3 seconds 
    // to deactivate all tabs in case of multiple tabs open with expired session
    if (jwtExp) {
      // Show active session message and disable login button for 3 seconds 
      // to allow time for other tabs to clear session and local storage
      this.btnActiveSession = true;  

      setTimeout(() => {      
        // After 3 seconds, enable the login button and allow user to attempt login again
          this.btnActiveSession = false;      
      }, 3000);   
    }
  },
  computed: {
    // Password confirmation rule for password reset
    passwordConfirmationRule() {
      return () => this.newPassword === this.confirmPassword || "Passwords must match";
    },
  },
  methods: {
    //Mounted calls
    initialCalls(){
      localStorage.clear();
      sessionStorage.clear();
      this.$vuetify.theme.dark = false;
      this.$vuetify.theme.themes["light"] = this.rlpTheme;
      this.getIP();
      EncryptUtility.localStorageEncrypt("showNav", false.toString());
      this.$store.commit("ConfigModule/showNav", false);
    },
    //To show password
    showPassword() {
      this.isPasswordShow = !this.isPasswordShow;
    },
    //User Login
    login() {
      localStorage.clear();
      if (!this.$refs.loginForm.validate()) return false;
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      var cipherpassword = EncryptUtility.passwordEncrypt(this.password);
      // var decrypted = EncryptUtility.passwordDecrypt(cipherpassword);
      let loginModel = {
        Email: this.email,
        Password: cipherpassword,
        Appcode: APPCODE,
        // SystemInfo: JSON.stringify(BrowserUtility.browserDetails()),
        SystemInfo: JSON.stringify(this.ipData),
      };
      this.axios
        .post("ap/login", loginModel)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let userIP = this.ipData?.ip;
            localStorage.clear();
            EncryptUtility.localStorageEncrypt("printerIP", userIP);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            EncryptUtility.localStorageEncrypt("showNav", true.toString());
            this.$store.commit("ConfigModule/showNav", true);
            let responseData = response.data.body;
            EncryptUtility.localStorageEncrypt("userID", responseData.UserId.toString());
            this.userId = responseData.UserId;
            EncryptUtility.localStorageEncrypt("fname", responseData.FName.toString());
            EncryptUtility.localStorageEncrypt("lname", responseData.LName.toString());
            EncryptUtility.localStorageEncrypt("email", responseData.Email.toString());
            EncryptUtility.localStorageEncrypt("installId", responseData.InstallId.toString());
            EncryptUtility.localStorageEncrypt("Token", responseData.Jwt);
            // let printerData = JSON.parse(responseData.Printer);
            // if (responseData?.Printer?.length !== 0 && responseData?.Printer !== null && responseData?.Printer !== undefined) {
            //   if (printerData[0]?.p_name !== null && printerData[0]?.p_name !== "") {
            //     EncryptUtility.localStorageEncrypt("primaryCheck", "true");
            //     EncryptUtility.localStorageEncrypt("primaryName", printerData[0]?.p_name);
            //     EncryptUtility.localStorageEncrypt("primaryLabelSize", printerData[0]?.p_size);
            //     EncryptUtility.localStorageEncrypt("primaryPrinterType", printerData[0]?.p_type);
            //   }
            //   if (printerData[0]?.s_name !== null && printerData[0]?.s_name !== "") {
            //     EncryptUtility.localStorageEncrypt("secondaryCheck", "true");
            //     EncryptUtility.localStorageEncrypt("secondaryName", printerData[0]?.s_name);
            //     EncryptUtility.localStorageEncrypt("secondaryLabelSize", printerData[0]?.s_size);
            //     EncryptUtility.localStorageEncrypt("secondaryPrinterType", printerData[0]?.s_type);
            //   }
            //   if (printerData[0]?.default_printer !== null && printerData[0]?.default_printer !== "") {
            //     EncryptUtility.localStorageEncrypt("defaultCheck", "true");
            //     EncryptUtility.localStorageEncrypt("defaultName", printerData[0]?.default_printer);
            //   }
            //   EncryptUtility.localStorageEncrypt("printerID", printerData[0]?.printer_id?.toString());
            // }
            authHeader(responseData.Jwt);
            this.decoded = jwt_decode(responseData.Jwt);
            this.expiredTime = this.decoded.exp * 1000;
            EncryptUtility.localStorageEncrypt("JWTExp", JSON.stringify(this.decoded.exp));
            EncryptUtility.localStorageEncrypt("themeCode", JSON.stringify(responseData.ThemeCode));
            if (responseData.ThemeCode == "Dark") {
              this.$vuetify.theme.dark = true;
              EncryptUtility.localStorageEncrypt(
                "theme",
                JSON.stringify(this.$vuetify.theme.dark)
              );
            } else if (responseData.ThemeCode == "Light") {
              this.$vuetify.theme.dark = false;
              EncryptUtility.localStorageEncrypt("theme", JSON.stringify(this.$vuetify.theme.dark));
            } else {
              this.$vuetify.theme.dark = false;
              EncryptUtility.localStorageEncrypt("theme", JSON.stringify(this.$vuetify.theme.dark));
            }
            
            // Check if password reset is required
            if (responseData.admin_pwd_reset === true) {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              // Store temp user data for password reset
              this.tempUserId = responseData.UserId;
              this.tempUserData = responseData;
              // Save the old password before clearing
              this.tempOldPassword = this.password;
              // Show password reset dialog
              this.passwordResetDialog = true;
              // Clear login form password field
              this.password = "";
            } else {
              // Normal login flow
              this.getExipryTime();
              this.createUniqSystemName();
              // Call getMenuList and wait for it to complete before navigation
              this.getMenuList().then(() => {
                this.$router.push("/home");
              });
            }
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.password = "";
          this.errorMessage = error.message;
        });
    },
    //To store URL in local storage
    getMenuList() {
      return new Promise((resolve, reject) => {
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.axios
          .get(`ap/user_menu?user_id=${this.userId}`)
          .then((response) => {
            if (
              response.status == 200 &&
              response.data !== undefined &&
              response.data.body !== undefined &&
              response.data.body.message !== undefined &&
              response.data.body.message !== undefined &&
              response.data.body.message !== null
            ) {
              let menuResponseData = response.data.body.message;
              if (
                menuResponseData !== "" &&
                menuResponseData !== undefined &&
                menuResponseData !== null
              ) {
                this.permission = JSON.parse(menuResponseData).Menus;
                //To Travarse Group level
                this.permission?.forEach((element) => {
                  //To Travarse sub group
                  element?.Childs.forEach((childelement) => {
                    //To Traverse between groups
                    childelement.ChildOfChilds?.forEach(
                      (childofchildelement) => {
                        //TO Traverse between Pages and get the URl
                        this.urlArray.push(childofchildelement.Url);
                        // To get the URLs in Page Level
                        //To Check if Child of child is present or not
                        if (
                          childofchildelement?.ChildOfChildOfChilds != undefined
                        ) {
                          childofchildelement?.ChildOfChildOfChilds.forEach(
                            (childofchildofchildelement) => {
                              //Push the Values inside a new Array
                              this.urlArray.push(
                                childofchildofchildelement.Url
                              );
                            }
                          );
                        }
                      }
                    );
                  });
                });
                // To remove empty values
                this.urlArray = this.urlArray.filter((item) => item);
                //To Show the user Profile Page;
                this.urlArray.push("user-profile");
                this.urlArray.push("printer-settings");
                this.urlArray.push("report-issue");
                this.urlArray.push("report-issue-details");
                this.urlArray.push("feedback-tracker");
                //this.urlArray.push("test");

                // To store the values in localstorage
                EncryptUtility.localStorageEncrypt(
                  "Url",
                  JSON.stringify(this.urlArray)
                );
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                resolve();
              } else {
                let Alert = {
                  type: "error",
                  isShow: true,
                  message:
                    "User is not associated with any role or do not have permission to menu.",
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                resolve();
              }
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              var Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              resolve();
            }
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
            reject(Alert);
          });
      });
    },
    //To check the expiration time and clear the local storage
    getExipryTime() {
      this.currentTime = new Date().getTime();
      if (this.currentTime > this.expiredTime) localStorage.clear();
    },
    //Get IP details
    getIP() {
      this.axios.get("https://ipapi.co/json/").then((response) => {
        this.ipData = [];
        this.ipData = response.data;
      });
    },
    //Create a unique system name
    createUniqSystemName() {
      if (
        this.$cookies.get("uniqueSystemName") !== "" &&
        this.$cookies.get("uniqueSystemName") !== undefined &&
        this.$cookies.get("uniqueSystemName") !== null
      ) {
        this.uniqSystemName = this.$cookies.get("uniqueSystemName");
        this.getPrinterDetails();
      }
    },
    async getPrinterDetails() {
      let printerObj = {
        json: JSON.stringify({
          user_id: parseInt(this.userId),
          pass: 1,
          printer_id: "",
          p_name: "",
          p_size: "",
          p_type: "",
          s_name: "",
          s_size: "",
          s_type: "",
          ip: "",
          default_printer: "",
          machine_name: this.uniqSystemName,
        }),
      };
      let showMessage = false;
      let printerData = await commonAPIService.userPrinterPreferences("post", printerObj, showMessage);
      if (printerData.message !== "NA") {
        if (printerData?.length !== 0 && printerData !== null && printerData !== undefined) {
          if (printerData[0]?.p_name !== null && printerData[0]?.p_name !== "") {
            EncryptUtility.localStorageEncrypt("primaryCheck", "true");
            EncryptUtility.localStorageEncrypt("primaryName", printerData[0]?.p_name);
            EncryptUtility.localStorageEncrypt("primaryLabelSize", printerData[0]?.p_size);
            EncryptUtility.localStorageEncrypt("primaryPrinterType", printerData[0]?.p_type);
          }
          if (printerData[0]?.s_name !== null && printerData[0]?.s_name !== "") {
            EncryptUtility.localStorageEncrypt("secondaryCheck", "true");
            EncryptUtility.localStorageEncrypt("secondaryName", printerData[0]?.s_name);
            EncryptUtility.localStorageEncrypt("secondaryLabelSize", printerData[0]?.s_size);
            EncryptUtility.localStorageEncrypt("secondaryPrinterType", printerData[0]?.s_type);
          }
          if (printerData[0]?.default_printer !== null && printerData[0]?.default_printer !== "") {
            EncryptUtility.localStorageEncrypt("defaultCheck", "true");
            EncryptUtility.localStorageEncrypt("defaultName", printerData[0]?.default_printer);
          }
          EncryptUtility.localStorageEncrypt("printerID", printerData[0]?.printer_id?.toString());
        }
      }
    },
    //Open forgot password dialog
    openForgotPasswordDialog() {
      this.forgotPasswordDialog = true;
      this.forgotEmail = "";
      this.captchaReceived = false;
      this.captchaCode = "";
      this.captchaText = "";
      this.captchaInput = "";
      if (this.$refs.forgotPasswordForm) {
        this.$refs.forgotPasswordForm.resetValidation();
      }
    },
    //Close forgot password dialog
    closeForgotPasswordDialog() {
      this.forgotPasswordDialog = false;
      this.forgotEmail = "";
      this.captchaReceived = false;
      this.captchaCode = "";
      this.captchaText = "";
      this.captchaInput = "";
      if (this.$refs.forgotPasswordForm) {
        this.$refs.forgotPasswordForm.resetValidation();
      }
    },
    //Submit forgot password - Validate email and get captcha
    submitForgotPassword() {
      // Frontend validation - email format and required check
      if (!this.$refs.forgotPasswordForm.validate()) {
        return false;
      }
      
      // Additional email format validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.forgotEmail)) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Please enter a valid email address",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        return false;
      }
      
      let LoaderDialog = {
        visible: true,
        title: "Validating Email...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      
      // API call to validate email and get captcha text
      let forgotPasswordModel = {
        user_email: this.forgotEmail,
        captcha: "",
        pass: 1
      };
      
      this.axios
        .post("ap/forgot-password", forgotPasswordModel)
        .then((response) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          
          if (response.status == 200 || response.status == 204) {
            // Check if response has captcha (now as plain text instead of image)
            if (response.data && response.data.body && response.data.body.message) {
              // Success - display captcha text
              this.captchaText = response.data.body.message;
              this.captchaReceived = true;
              
              let Alert = {
                type: "success",
                isShow: true,
                message: "Email validated successfully! Please enter the captcha code shown below.",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            } else {
              // No captcha in response
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message || "Unable to process request. Please try again.",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
          } else {
            // API returned non-success status
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message || "Email validation failed",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          
          // Handle error - display error message from API
          let errorMessage = "An error occurred. Please try again.";
          
          if (error.response && error.response.data && error.response.data.message) {
            // If API returns specific error message (e.g., "Email not found")
            errorMessage = error.response.data.message;
          } else {
            errorMessage = Utility.apiError(error);
          }
          
          let Alert = {
            type: "error",
            isShow: true,
            message: errorMessage,
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    //Submit captcha verification - Pass 2
    submitCaptchaVerification() {
      // Validate captcha input
      if (!this.captchaInput || this.captchaInput.trim() === "") {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Please enter the captcha code",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        return false;
      }
      
      let LoaderDialog = {
        visible: true,
        title: "Verifying Captcha...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      
      // API call to verify captcha and trigger password reset email
      let forgotPasswordModel = {
        user_email: this.forgotEmail,
        captcha: this.captchaInput.trim(),
        pass: 2
      };
      
      this.axios
        .post("ap/forgot-password", forgotPasswordModel)
        .then((response) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          
          if (response.status == 200 || response.status == 204) {
            // Success - password reset email sent
            let Alert = {
              type: "success",
              isShow: true,
              message: "Password reset email has been sent successfully! Please check your inbox.",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            
            // Close the dialog
            this.closeForgotPasswordDialog();
          } else {
            // API returned non-success status
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message || "Captcha verification failed",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          
          // Handle error - display error message from API
          let errorMessage = "An error occurred. Please try again.";
          
          if (error.response && error.response.data && error.response.data.message) {
            // If API returns specific error message (e.g., "Invalid captcha")
            errorMessage = error.response.data.message;
          } else {
            errorMessage = Utility.apiError(error);
          }
          
          let Alert = {
            type: "error",
            isShow: true,
            message: errorMessage,
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    // Password Reset Methods
    showNewPassword() {
      this.isNewPasswordShow = !this.isNewPasswordShow;
    },
    showConfirmPassword() {
      this.isConfirmPasswordShow = !this.isConfirmPasswordShow;
    },
    // Submit password reset
    submitPasswordReset() {
      // Validate form
      if (!this.$refs.passwordResetForm.validate()) {
        return false;
      }
      
      // Additional validation - check if passwords match
      if (this.newPassword !== this.confirmPassword) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Passwords do not match",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        return false;
      }
      
      let LoaderDialog = {
        visible: true,
        title: "Updating Password...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);

      // const encryptedOldPassword = EncryptUtility.passwordEncrypt(this.tempOldPassword);
      // const encryptedNewPassword = EncryptUtility.passwordEncrypt(this.confirmPassword);
      
      // Call password reset endpoint
      let passwordModel = {
        UserId: this.tempUserId,
        OldPassword: this.tempOldPassword,
        NewPassword: this.confirmPassword,
        IsUser: true
      };
      
      this.axios
        .post("ap/user_pwd_reset", passwordModel)
        .then((response) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message || "Password updated successfully! Please login with your new password.",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            
            // Close dialog and reset form
            this.passwordResetDialog = false;
            this.newPassword = "";
            this.confirmPassword = "";
            if (this.$refs.passwordResetForm) {
              this.$refs.passwordResetForm.resetValidation();
            }
            
            // Clear stored data
            localStorage.clear();
            this.tempUserId = null;
            this.tempUserData = null;
            this.tempOldPassword = "";
            
            // Reset login form
            this.email = "";
            this.password = "";
            if (this.$refs.loginForm) {
              this.$refs.loginForm.resetValidation();
            }
            
            // Keep user on login page to login with new password
            EncryptUtility.localStorageEncrypt("showNav", false.toString());
            this.$store.commit("ConfigModule/showNav", false);
          } else {
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message || "Password update failed",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
  },
};
